import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { notify } from "../actions/CommonActions";

export const ModalBulkDebit = ({
  show,
  toggle,
  handleUpdateResumptionDate,
  isUpdating,
  allMandates
}) => {
  
  const navigate = useNavigate();
  return (
    <Modal show={show} onHide={toggle} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Bulk Debit Mandate</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to debit the selected {allMandates?.length} mandates?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          style={{
            // backgroundColor: "red",
            fontSize: "0.8rem",
            fontWeight: 500,
            border: 0,
          }}
          onClick={async () => {
              await handleUpdateResumptionDate();
          }}
          disabled={isUpdating}
        >
          {isUpdating ? "Debitting, please wait.." : "Proceed to debit"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
